import EditorOutput from '@/components/common/EditorOutput';
import { Container } from '@/components/ui/Grid';
import MotionHeader from '@/components/ui/MotionHeader';
import Advantages from './Advantages';
import Statistics from './Statistics';
import Team from './Team';
import styles from './about.module.scss';
import {motion} from "framer-motion";

const About = ({ data = {} }) => {
  const firstParagraph = {
    ...data?.text,
    blocks: [
        data.text?.blocks?.[0]
    ]
  }
  const otherParagraphs = {
    ...data?.text,
    blocks: data.text?.blocks?.slice(1)
  }

  const variants = {
    initial: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 1.3,
        delay: 0.5,
      },
    },
    hidden: { opacity: 0 },
  };
  return (
      <Container>
        {data.title && <MotionHeader>{data.title}</MotionHeader>}
        {data.text && <EditorOutput data={firstParagraph}/>}

        <motion.div
            initial="initial"
            animate="visible"
            exit="hidden"
            variants={variants}
            className={styles.quoteBlock}
        >
          <img src={'/static/director.jpeg'} className={styles.quoteImg} alt={'Генеральный директор'}/>
          <div className={styles.quoteText}>
            <p className={styles.quote}>«Наша амбиция – стать игроком номер один в России и СНГ, укрепить лидерство
              брендов AGAMA, "Меридиан" и Unifrost, расширить дистрибуцию и стимулировать культуру потребления рыбы за
              счет качества, удобства и инноваций. Наша стратегия ориентирована на последовательное повышение
              эффективности, с сохранением бескомпромиссного качества для наших потребителей»</p>
            <p>– Антон Уланов, генеральный директор группы компаний «Юнифрост»</p>
          </div>
        </motion.div>

        {data.text && <EditorOutput data={otherParagraphs}/>}
        {data.blocks &&
            Array.isArray(data.blocks) &&
            data.blocks.map(block => {
              switch (block.block_name) {
                case 'About_Advantages':
                  return <Advantages key={block.id} data={block}/>;

                case 'About_Statistics':
                  return <Statistics key={block.id} data={block}/>;

                default:
                  return null;
              }
            })}
        {data.team && data.team.length > 0 && <Team data={data.team}/>}
        {/*{data.documents && data.documents.length > 0 && <Docs data={data.documents} />}*/}
      </Container>
  );
};

export default About;
